import http from '../jslibs/axios/http'

// 获取seo列表
export const getSettingSEO = data => http.get('/v1/cms/SettingSEO', data)

// 编辑seo
export const editSettingSEO = (id, data) => http.put(`/v1/cms/SettingSEO/${id}`, data)

// 获取seo详情
export const settingSEODetail = (id) => http.get(`/v1/cms/SettingSEO/${id}`)
